import React, { useState } from 'react';
import { Box, Split } from '@dropbox/dig-foundations';
import { Checkbox } from '@dropbox/dig-components/controls';
import { FormLabel } from '@dropbox/dig-components/form_row';
import { defineMessages, useIntl } from 'react-intl';
import { useSignerContext } from 'signer-app/signer-experience/signer-experience';
import { EsignDisclosureModal } from 'signer-app/esign-disclosure/esign-disclosure-modal';
import { createDownloadUrl } from 'signer-app/esign-disclosure/utils';
import { WhiteLabelThemeProvider } from 'signer-app/white-labeling/theme-provider';
import { Link } from '@dropbox/dig-components/typography';

const messages = defineMessages({
  headertext: {
    id: '57014d5bd0a1915de8c9bdda85d2748e76a1ba0d111b4386d9133be705001949',
    description:
      'text in signer flow, edisclosure for signer to click before signing',
    defaultMessage: 'I agree to {link} by {businessName}.',
  },
  headerLinkText: {
    id: 'ccef287d184ab6217bf995e13a88ff43806b6ddbfb1042c6c35a86f5a3d64402',
    description:
      'text in signer flow, edisclosure for signer to click before signing',
    defaultMessage: 'electronic records and signature agreement*',
  },
});

export function EsignDisclosureControl() {
  const {
    esignDisclosure,
    esignDisclosureOptIn,
    isComingFromSmsDelivery,
    transmissionGuid,
  } = useSignerContext();
  const intl = useIntl();
  const [viewingDisclosure, setViewingDisclosure] = useState(false);
  if (!esignDisclosure) {
    return null;
  }

  return (
    <>
      <Split gap="Micro Medium">
        <Split.Item>
          <Checkbox
            id="esign-disclosure"
            checked={esignDisclosure.userOptIn}
            onChange={() =>
              esignDisclosureOptIn({
                transmissionGuid,
                isComingFromSmsDelivery,
                esignDisclosureId: esignDisclosure.id,
              })
            }
          />
        </Split.Item>
        <Split.Item>
          <Box
            as={FormLabel}
            display="inline"
            variant="control"
            htmlFor="esign-disclosure"
          >
            {intl.formatMessage(messages.headertext, {
              // due to button not supporting being inline and we need to somehow indicate that it can be clicked we use a link but it's not ideal
              link: (
                <Link
                  href=""
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setViewingDisclosure(true);
                  }}
                >
                  {intl.formatMessage(messages.headerLinkText)}
                </Link>
              ),
              businessName: esignDisclosure.businessName,
            })}
          </Box>
        </Split.Item>
      </Split>
      <WhiteLabelThemeProvider colors="reset" mode="bright">
        <EsignDisclosureModal
          open={viewingDisclosure}
          esignDisclosure={esignDisclosure}
          downloadUrl={createDownloadUrl(esignDisclosure, transmissionGuid)}
          onRequestClose={() => setViewingDisclosure(false)}
        />
      </WhiteLabelThemeProvider>
    </>
  );
}
